module.exports = __webpack_public_path__ + "je.svg?2e77a728f07a9f1b0687621eb69b3a31";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/je.svg
// module id = 844
// module chunks = 27